// extracted by mini-css-extract-plugin
module.exports = {"amountInputCol":"advanceRow_amountInputCol__2_2kh","amountInputGroup":"advanceRow_amountInputGroup__2iRVq"};